Ext.define('SA.lq.view.ExportWidgetFactory', {
    constructor({userEmailAddress, canEnableExportBtn}) {
        this.userEmailAddress = userEmailAddress;
        this.canEnableExportBtn = canEnableExportBtn;
    },

    createWidget() {
        var widget = Ext.widget({xtype: 'lq-export-widget'}),
            refreshExportBtnEnabled = () => widget.setExportBtnEnabled(this.canEnableExportBtn(widget)),
            refreshEmailSectionVisible = () => widget.setEmailSectionVisible(widget.deliveryTypeSwitchValueIsEmail());

        widget.loadMask = widget.down('#loadMask');
        widget.limitMessageEl = widget.down('#limitMessage');
        widget.fileFormatRadioGroup = widget.down('#fileFormatRadioGroup');
        widget.deliveryTypeSwitch = widget.down('#deliveryTypeSwitch');
        widget.emailSection = widget.down('#emailSection');
        widget.emailAddressField = widget.down('#emailAddress');
        widget.emailMessageTextarea = widget.down('#emailMessage');
        widget.exportBtn = widget.down('#exportBtn');
        widget.cancelBtn = widget.down('#cancelBtn');

        widget.emailAddressField.setValue(this.userEmailAddress);

        widget.deliveryTypeSwitch.on('change', () => {
            refreshEmailSectionVisible();
            refreshExportBtnEnabled();
        });

        widget.emailAddressField.on('change', refreshExportBtnEnabled);

        return widget;
    }
});